import { IMultiNavRoute, ISingleNavRoute } from 'app/components/navigation/Nav/interfaces'
import { History } from 'history'
import * as React from 'react'
import * as ListGroup from 'react-bootstrap/lib/ListGroup'
import * as ListGroupItem from 'react-bootstrap/lib/ListGroupItem'
import * as ReactDOM from 'react-dom'
import { NavLink } from 'react-router-dom'
import * as Redux from 'redux'

export interface INavItemProps {
  multiConfig?: IMultiNavRoute
  singleConfig?: ISingleNavRoute
  history?: History
}

export interface INavItemState {
  path: string
  forceOpen: boolean
}

class NavItem extends React.Component<INavItemProps, INavItemState> {

  unlisten: Redux.Unsubscribe
  state = {
    path: '',
    forceOpen: undefined,
  }

  componentWillMount() {
    if (this.props.history) {
      this.unlisten = this.props.history.listen((location) => {
        this.setState({ path: location.hash })
      })
    }
  }

  componentWillUnmount() {
    if (typeof this.unlisten === 'function') {
      this.unlisten()
    }
  }

  getListGroupClass() {
    let classes = 'list-group-item-inner-list'
    let hasMatch = false

    if (this.state.forceOpen === false) {
      return classes
    }

    // tslint:disable-next-line:prefer-conditional-expression
    if (this.props.multiConfig) {
      hasMatch = this.props.multiConfig.routes
        .filter((r) => this.state.path.indexOf(r.path) >= 0).length > 0
    } else {
      hasMatch = this.state.path.indexOf(this.props.singleConfig.path) >= 0
    }

    if (hasMatch || this.state.forceOpen) {
      classes += ' open'
    }

    return classes
  }

  toggleForceOpen(e) {
    const parentElem = ReactDOM.findDOMNode(this)
    if (parentElem === e.target) {
      this.setState({ forceOpen: !this.state.forceOpen })
    }
  }

  render() {
    if (this.props.multiConfig) {
      return (
        <ListGroupItem className={this.getListGroupClass()} onClick={this.toggleForceOpen.bind(this)}>
          <i className={this.props.multiConfig.iconClass}></i>
          {this.props.multiConfig.name}

          <ListGroup className="list-group-clear">
            {this.props.multiConfig.routes.map((route, index) => (
              <NavLink key={index} exact to={route.path} activeClassName="active" className="list-group-item">
                {route.name}
              </NavLink>
            ))}
          </ListGroup>
        </ListGroupItem>
      )
    } else {
      return (
        <NavLink exact to={this.props.singleConfig.path} className="list-group-item">
          <i className={this.props.singleConfig.iconClass}></i>
          {this.props.singleConfig.name}
        </NavLink>
      )
    }
  }
}

export {
  NavItem,
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/NavItem/index.tsx